import axios from "axios";
import { baseApiUrl, getHttpHeaders, httpRequest } from "./ApiUtils";
import { adnPageSize } from "../components/common/GeneralConfigurations";

const userApiUrl = `${baseApiUrl}/api/Users`;

export async function getUsers(
  pageNumber = 1,
  pageSize = adnPageSize,
  orderBy = "",
  searchName = "",
  searchEmail = "",
  searchDepartmentName = "",
  status = "false"
) {
  return await httpRequest(
    fetchUsers.bind(
      this,
      pageNumber,
      pageSize,
      orderBy,
      searchName,
      searchEmail,
      searchDepartmentName,
      status
    )
  );
}
async function fetchUsers(
  pageNumber,
  pageSize,
  orderBy,
  searchName,
  searchEmail,
  searchDepartmentName,
  status
) {
  let config = getHttpHeaders();
  return await axios.get(
    `${userApiUrl}?pageNumber=${pageNumber}&pageSize=${pageSize}
  &orderBy=${orderBy}&name=${searchName}&email=${searchEmail}&departmentName=${searchDepartmentName}&deleted=${status}`,
    config
  );
}

export async function getUserById(id) {
  return await httpRequest(fetchUserById.bind(this, id));
}

async function fetchUserById(id) {
    let config = getHttpHeaders();
  return await axios.get(`${userApiUrl}/${id}`, config);
}

export async function checkIfEmployeeIsUnderManager(employeeId, managerId) {
  return await httpRequest(
    fetchCheckIfEmployeeIsUnderManager.bind(this, employeeId, managerId)
  );
}

async function fetchCheckIfEmployeeIsUnderManager(employeeId, managerId) {
  let config = getHttpHeaders();
  return await axios.get(
    `${userApiUrl}/CheckIfManager?employeeId=${employeeId}&managerId=${managerId}`,
    config
  );
}

export async function addUser(newUser) {
  return await httpRequest(postUser.bind(this, newUser));
}

async function postUser(newUser) {
  let config = getHttpHeaders();
  return await axios.post(`${userApiUrl}`, newUser, config);
}

export async function updateUser(id, updatedUser) {
  return await httpRequest(putUser.bind(this, updatedUser, id));
}

async function putUser(updatedUser, id) {
  let config = getHttpHeaders();
  return await axios.put(`${userApiUrl}`, { ...updatedUser, id }, config);
}

export async function deleteUser(id) {
  return await httpRequest(fetchDeleteUser.bind(this, id));
}

async function fetchDeleteUser(id) {
  let config = getHttpHeaders();
  return await axios.delete(`${userApiUrl}/${id}`, config);
}

export async function GetUserByDepartmentId(id) {
  return await httpRequest(getUserByDepartmentId.bind(this, id));
}

async function getUserByDepartmentId(id) {
  let config = getHttpHeaders();
  return await axios.get(`${userApiUrl}/DepartmentId/${id}`, config);
}

export async function addPassword(updatedPassword) {
  return await httpRequest(postUserPassword.bind(this, updatedPassword));
}

async function postUserPassword(updatedPassword) {
  let config = getHttpHeaders();
  return await axios.post(
    `${baseApiUrl}/api/auth/change-password`,
    updatedPassword,
    config
  );
}

export async function SendRecoverEmail(email) {
  return await axios.post(`${baseApiUrl}/api/Auth/forgot-password`, email);
}

export async function getUserByActivationKey(activationKey) {
  return await axios.get(`${userApiUrl}/ActivationKey/${activationKey}`);
}

export async function postUserPasswordByActivationKey(
  activationKey,
  password,
  passwordConfirmation
) {
  let config = getHttpHeaders();
  return await axios.post(`${baseApiUrl}/api/Auth/activate-account`, {
    activationKey,
    password,
    passwordConfirmation,
  }, config);
}
